<template>
	<div>
		<!--
        <div class="container is-fullhd">
            <div class="tabs is-toggle">
                <ul>
                    <li :class="{ 'is-active': activePageName == 'draft_dashboard' }">
                        <router-link :to="{ name: 'league-draft-dashboard' }">Overview</router-link>
                    </li>
                    <li :class="{ 'is-active': activePageName == 'draft_rounds' }">
                        <router-link :to="{ name: 'league-draft-rounds' }">Rounds</router-link>
                    </li>
                    <li :class="{ 'is-active': activePageName == 'draft_teams' }">
                        <router-link :to="{ name: 'league-draft-teams' }">Teams</router-link>
                    </li>
                </ul>
            </div>
        </div>
		-->

		<router-view />
	</div>
</template>

<script>
export default {
	computed: {
		activePageName() {
			return this.$store.getters.activePageName
		},
	},
}
</script>

<style scoped>
.tabs {
	margin: 1.5rem 0;
}

@media (max-width: 768px) {
	.tabs {
		margin-left: 1rem;
		margin-right: 1rem;
	}

	.tabs > ul > li {
		flex: 1;
	}
}
</style>
